<template>
  <div class="main">
    <el-form :rules="rules" :model="form" ref="form">
      <el-form-item prop="instructionsType"    >
        <div class="flex_r f_jc_b">
        <img :class="[form.instructionsType === 0 ? 'none' : '']" @click="handleType(0)" src="../assets/instructions/Frame117.png">
        <img :class="[form.instructionsType === 1 ? 'other' : '']" @click="handleType(1)" src="../assets/instructions/Frame118.png">
        </div>
      </el-form-item>
      <el-form-item prop="name"   >
        <div class="fs14 fw400" style="color:rgba(130, 130, 130, 1) ;margin-bottom: 8px ">产品信息</div>
        <div class="flex_r" style="gap: 10px   ">
          <el-input style="width: 190px" placeholder="产品名称"  v-model="form.name"></el-input>
          <el-cascader :options="typeTree" :show-all-levels="false" v-model="form.category" placeholder="请选择产品类型"  ></el-cascader>
        </div>
      </el-form-item>
      <el-form-item prop="model"   >
        <div v-if="form.instructionsType === 0" class="fs14 fw400" style="color:rgba(130, 130, 130, 1) ;margin-bottom: 8px ">规格型号
        </div>
        <div v-if="form.instructionsType === 0" class="flex_r" style="gap: 10px  ">
          <el-input placeholder="输入产品规格型号或特性"   v-model="form.model" ></el-input>
        </div>
      </el-form-item>
      <el-form-item prop="identIficationCode"   >
        <div class="fs14 fw400" style="color:rgba(130, 130, 130, 1) ;margin-bottom: 8px ">唯一识别码</div>
        <div class="flex_r" style="gap: 10px  ">
          <el-input placeholder="输入产品规格型号或特性" v-model="form. identIficationCode"></el-input>
          <el-button style="background-color:  #00EE7A;width: 120px" @click="autoCodeHandle">随机</el-button>
        </div>
      </el-form-item>
      <el-form-item prop="titileImg"   >
        <div class="fs14 fw400 flex_r f_jc_b f_ai_c" style="color:rgba(130, 130, 130, 1);margin-bottom: 8px ">
          <div>封面图片</div>
          <div style="color: rgba(3, 17, 44, 0.18);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;">推荐尺寸：400*400PX</div>
        </div>
        <div class="Card flex_r f_jc_c f_ai_c" v-if="!form.titileImg">
          <el-upload
              :action="uploadURL + '/uoloadFiles'"
              :on-success="uploadLogoSuccess"
              accept=".png,.jpg,.jpeg,.bmp"
              multiple
              :limit="1"
              :headers="{ token: token }"
              :show-file-list="false"
          >
            <i class="el-icon-plus" style="font-size: 30px"></i>
          </el-upload>
        </div>
        <div class="Card flex_r f_jc_c f_ai_c" v-if="form.titileImg">

          <img :src="`${this.form.titileImg}`" style="width: 100%;height: 100%" >
          <div class="changeUpload">
            <el-upload
                :action="uploadURL + '/uoloadFiles'" multiple :on-success="uploadLogoSuccess"
                :headers="{ 'token': token }"
                :show-file-list="false"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15.1888 6.75005L13.1191 3.53062L14.3809 2.71948L17.1934 7.09448C17.3418 7.32526 17.3523 7.61864 17.2208 7.85944C17.0893 8.10025 16.8369 8.25005 16.5625 8.25005H2.81251V6.75005H15.1888ZM2.76296 12.1722C2.88847 11.914 3.15039 11.7501 3.43751 11.7501H17.1875V13.2501H4.9806L7.46475 16.4117L6.28527 17.3384L2.84777 12.9634C2.67038 12.7377 2.63745 12.4304 2.76296 12.1722Z" fill="black"/>
              </svg>
            </el-upload>
          </div>
        </div>

      </el-form-item >
        <div class="remarks" v-if="typeIndex === 1">
          注：着移动端，“其他说明书”只可以通过复制唯一识别码在搜索框搜索，无法使用标题搜索到结果。
        </div>
      <div class="flex_r  " style="flex-direction: row-reverse">
      </div>
    </el-form>

  </div>
</template>
<script>
import {getPmodelUUid, fetchProductClassList, fetchInstructionsDetail, getTypeTree} from '../api/console'
import {mapGetters,createNamespacedHelpers} from 'vuex'
import {uploadURL} from '@apis/url'
const { mapState } = createNamespacedHelpers('templant')

export default {
  name: 'creatInstructions',
  props:['type'],
  data() {
    const validatorTitileImg=(rule, value, callback)=>{
      if(!this.form.titileImg){
        callback(new Error('请上传封面图片'))
      }else {
        callback()
      }
    }
    return {
      typeIndex: 0,
      allClassList: [],
      form: {
        instructionsType: 0,//产品类型
        name: null,//产品名称
        titileImg: null,//封面图片
        category: null,//产品分类
        model: null,//产品型号
        identIficationCode: null,//唯一识别码
      },
      uploadURL:uploadURL,
      fileList:[],
      rules:{
        name:{ required: true, message:'请填写说明书名字', trigger: 'blur' },
        category:{ required: true, message:'请输选择产品分类', trigger: 'blur' },
        model:{required: true, message:'请填写产品型号', trigger: 'blur'},
        identIficationCode:{required: true, message:'请设置唯一识别吗', trigger: 'blur'},
        titileImg:{
          validator:validatorTitileImg,
          trigger: 'blur'
        }
      },
      typeTree:[]
    }
  },
  computed:{
    ...mapGetters(['token', 'userInfo']),
    ...mapState(['instructions']),

  },
  methods: {
    handleType(index) {
      this.typeIndex = index
      this.form.instructionsType=index
    },
    close() {
      this.$emit('close')
    },
    autoCodeHandle() {
      getPmodelUUid().then(res => {
        this.form.identIficationCode = res;
      })
    },
    uploadLogoSuccess(response) {
      this.form.titileImg = 'https://' + response.data.url
    },
    fetchAllProductClassList() {
      fetchProductClassList({}).then((res) => {
        this.allClassList = res;
      });
    },
    // @ 没数据
    getTypeList(){
      getTypeTree().then(e=>{
        this.typeTree=this.getTree(e)

        console.log(this.getTree(e))

      })
    },
    getTree(data){
      if(data.length>0){
          return  data.map(item=>{
            if(item.children.length>0){
              return {
                value:item.id,
                label:item.name,
                children:this.getTree(item.children)
              }
            }else {
              return {
                value:item.id,
                label:item.name,
              }
            }
          })
      }else {
          return []
      }
    }
  },
  mounted(){
    this.fetchAllProductClassList()
    this.getTypeList()
    if(this.type=='change'){
      fetchInstructionsDetail({
        id:this.instructions.instructionsId
      }).then(e=>{

        this.form.instructionsType=e.instructions.instructionsType
        this.form.name=e.instructions.name
        this.form.category=e.instructions.pclass
        this.form.identIficationCode=e.instructions.identIficationCode
        this.form.titileImg=e.instructions.titileImg
        this.form.model=e.instructions.pmodel
        this.fileList=[{name:'封面',url:e.instructions.titileImg}]
      })
    }
  }
}

</script>
<style scoped lang="scss">
.main {
  width: 412px;
  box-sizing: border-box;
  margin: auto;
}
.Card{
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
  position: relative;
}

.none {
  border-radius: 4px;
  border: 2px solid #FCE783;
  background: rgba(252, 231, 131, 0.24);
}

.other {
  border-radius: 4px;
  border: 2px solid #B560FF;
  background: rgba(181, 96, 255, 0.10);
}
.changeUpload{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  width: 36px;
  height: 36px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 36px;
  background: rgba(255, 255, 255, 0.60);
  z-index: 9;
}
.remarks {
  padding: 14px 10px 26px 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: #F5F5F5;
  color: #B560FF;
  margin-bottom: 18px;
  font-family: "Alibaba PuHuiTi 3.0";
  font-size: 13px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}
.uploadBox{
  position: relative;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;

}
.uplaodIcon{
  position: absolute;
  left: 50%;
  right: 50%;
  font-size: 20px;
  border: solid 1px red;
  transform: translate(-50%,-50%);
  z-index: 999;

}
</style>
